import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';

@Injectable()
export class HeaderFactory {

    constructor() {
        //
    }

    make(): Headers {
        const headers = new Headers();

        headers.append('Content-Type', 'application/json');

        if (window['mgr']) {
            headers.append('Authorization', `Bearer ${window['mgr'].access_token}`);
        }

        return headers;
    }

}


/** WEBPACK FOOTER **
 ** ./app/common/HeaderFactory.ts
 **/